<div class="linked-patients">
  <div class="linked-head">
    <p class="linked-copy">
      Connect related profiles without merging orders, prescriptions, payments, or notes.
    </p>
    <button type="button" class="ao-button" (click)="managing = !managing">
      {{ managing ? 'CLOSE' : 'MANAGE CONNECTIONS' }}
    </button>
  </div>

  <div class="linked-list">
    <div class="linked-row" *ngFor="let link of links">
      <mat-icon>{{ kindIcon(link) }}</mat-icon>
      <div class="linked-person">
        <div class="linked-name">{{ link.patient?.firstName }} {{ link.patient?.lastName }}</div>
        <div class="linked-meta">{{ relationshipLabel(link) }}<span *ngIf="link.patient?.patientNumber"> · Patient #{{ link.patient.patientNumber }}</span></div>
      </div>
      <button type="button" class="ao-button" (click)="openProfile(link)">VIEW</button>
      <button *ngIf="managing" mat-button type="button" (click)="edit(link)">EDIT</button>
      <button *ngIf="managing" mat-button type="button" (click)="remove(link)">REMOVE</button>
    </div>
  </div>
  <p *ngIf="!links.length" class="empty">No linked patients yet.</p>

  <div class="add-row ao-fields" *ngIf="managing">
    <app-autocomplete-patient
      placeholder="SEARCH EXISTING PATIENT"
      mode="link"
      [excludePatientId]="patient?._id"
      (selectedPatient)="onSelectPatient($event)"
    ></app-autocomplete-patient>
    <mat-form-field floatLabel="always" subscriptSizing="dynamic">
      <mat-label>RELATIONSHIP</mat-label>
      <mat-select
        [(ngModel)]="relationship"
        [ngModelOptions]="{standalone: true}"
        panelClass="linked-patients-panel"
      >
        <mat-option *ngFor="let option of relationships" [value]="option">{{ option | uppercase }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="relationship === 'Other'" floatLabel="always" subscriptSizing="dynamic">
      <mat-label>DESCRIPTION</mat-label>
      <input matInput [(ngModel)]="otherDescription" [ngModelOptions]="{standalone: true}" autocomplete="off">
    </mat-form-field>
    <span class="selected-name" *ngIf="selectedPatient?._id">
      {{ selectedPatient.lastName }}, {{ selectedPatient.firstName }}
    </span>
    <button
      class="ao-button"
      type="button"
      [disabled]="busy || !canSave()"
      (click)="addOrUpdate()"
    >
      {{ editingId ? 'UPDATE LINK' : 'ADD LINKED PATIENT' }}
    </button>
  </div>

  <div class="history" *ngIf="history.length">
    <div class="history-title">RELATIONSHIP HISTORY</div>
    <p *ngFor="let event of history">
      {{ event.initials }} — {{ event.date | date:'short' }} — {{ event.item }}
      <span *ngIf="event.notes"> ({{ event.notes }})</span>
    </p>
  </div>
</div>
